module.exports = __webpack_public_path__ + "static/media/ekran-woda.01778f89.svg";